/* @ngInject */

export default ($timeout, eventService) => {
  return {
    restrict: 'A',
    scope: {
      stInputInsertValue: '='
    },
    link: function (scope, element, attrs) {
      eventService.onInputInsertValue(attrs.stInputInsertValue.toString(), function (payload) {
        $timeout(function () {
          var domElement = element[0];
          if (document.selection) {
            domElement.focus();
            var sel = document.selection.createRange();
            sel.text = payload;
            domElement.focus();
          } else if (domElement.selectionStart || domElement.selectionStart === 0) {
            var startPos = domElement.selectionStart;
            var endPos = domElement.selectionEnd;
            var scrollTop = domElement.scrollTop;
            domElement.value =
              domElement.value.substring(0, startPos) +
              payload +
              domElement.value.substring(endPos, domElement.value.length);
            domElement.focus();
            domElement.selectionStart = startPos + payload.length;
            domElement.selectionEnd = startPos + payload.length;
            domElement.scrollTop = scrollTop;
          } else {
            domElement.value += payload;
            domElement.focus();
          }
          var $e = angular.element(domElement);
          $e.triggerHandler('input');
        });
      });
    }
  };
};
